'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('react-dom/client');
var reactBootstrap = require('react-bootstrap');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

class ConfirmationDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { show: true };
        this.hide = () => this.setState({ show: false });
        this.confirm = (event) => {
            const { onConfirm } = this.props;
            event.stopPropagation();
            event.preventDefault();
            this.hide();
            if (onConfirm) {
                onConfirm(event);
            }
        };
        this.cancel = () => {
            const { onCancel } = this.props;
            this.hide();
            if (onCancel) {
                onCancel();
            }
        };
        this.dismiss = () => {
            const { onDismiss } = this.props;
            this.hide();
            if (onDismiss) {
                onDismiss();
            }
        };
    }
    render() {
        const { body, title, confirmLabel, cancelLabel, enableEscape } = this.props;
        const { show } = this.state;
        return (React__default["default"].createElement("div", { className: "static-modal" },
            React__default["default"].createElement(reactBootstrap.Modal, { show: show, onHide: this.dismiss, backdrop: enableEscape ? true : 'static', keyboard: enableEscape },
                React__default["default"].createElement(reactBootstrap.Form, { onSubmit: this.confirm },
                    React__default["default"].createElement(reactBootstrap.Modal.Header, null,
                        React__default["default"].createElement(reactBootstrap.Modal.Title, null, title)),
                    React__default["default"].createElement(reactBootstrap.Modal.Body, null, body),
                    React__default["default"].createElement(reactBootstrap.Modal.Footer, null,
                        React__default["default"].createElement(reactBootstrap.Button, { variant: "outline-secondary", onClick: this.cancel }, cancelLabel),
                        React__default["default"].createElement(reactBootstrap.Button, { className: "button-l", variant: "primary", type: "submit" }, confirmLabel))))));
    }
}
ConfirmationDialog.defaultProps = {
    title: 'Confirmation',
    confirmLabel: 'Yes',
    cancelLabel: 'No',
    enableEscape: true,
    onConfirm: () => undefined,
    onCancel: () => undefined,
    onDismiss: () => undefined,
};
const confirm = (body, props = {}, unmountDelay = 1000, mountingNode = document.body) => {
    const divElement = document.createElement('div');
    const wrapper = mountingNode.appendChild(divElement);
    const root = client.createRoot(wrapper);
    const dispose = () => {
        setTimeout(() => {
            root.unmount();
            setTimeout(() => mountingNode.removeChild(wrapper));
        }, unmountDelay);
    };
    const promise = new Promise((resolve, reject) => {
        root.render(React__default["default"].createElement(ConfirmationDialog, Object.assign({ onConfirm: () => resolve(true), onCancel: reject, onDismiss: dispose, body: body }, props)));
    });
    return promise.then(dispose, () => {
        dispose();
        return Promise.reject();
    });
};

exports.ConfirmationDialog = ConfirmationDialog;
exports["default"] = confirm;
